"use client";

import { useUserRealmId } from "@easybiz/component-shared";
import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

export default (emailId) => {
  const realmId = useUserRealmId();
  const [deviceDoc, setDeviceDoc] = useState();

  // Device doc
  useEffect(() => {
    if (emailId && realmId) {
      return onSnapshot(doc(getFirestore(), `realms/${realmId}/emails/${emailId}`), setDeviceDoc);
    }
  }, [emailId, realmId]);

  return deviceDoc;
};
